var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:(_vm.customStyleVar)},[_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"},on:{"before-enter":_vm.onEnter,"before-leave":_vm.onLeave,"after-enter":_vm.afterEnter}},[(!_vm.blockScreen)?_c('router-view',{staticClass:"page"}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }